export class SearchModel {
  searchString: string = '';
  currentPage: number = 1;
  perPage: number = 50;
  lastPage: number = 1;
}
